import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "input-known-ssh-hosts labeled-input",
  "data-testid": "input-known-ssh-hosts"
}
const _hoisted_2 = {
  class: "hosts-input",
  "data-testid": "input-known-ssh-hosts_summary"
}
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, _toDisplayString(_ctx.t('secret.ssh.knownHosts')), 1),
    _cache[1] || (_cache[1] = _createTextVNode()),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.summary), 1),
    _cache[2] || (_cache[2] = _createTextVNode()),
    (!_ctx.isViewMode)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          id: "known-ssh-hosts-trigger",
          ref: "button",
          role: "button",
          "aria-label": _ctx.t('secret.ssh.editKnownHosts.title'),
          "data-testid": "input-known-ssh-hosts_open-dialog",
          class: "show-dialog-btn btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDialog && _ctx.openDialog(...args)))
        }, [
          _createElementVNode("i", {
            class: "icon icon-edit",
            alt: _ctx.t('secret.ssh.editKnownHosts.title')
          }, null, 8, _hoisted_4)
        ], 8, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}